export default 'Particuliers : rénovez votre logement à coût maîtrisé. Cumul MaPrimeRénov’ + CEE + éco-PTZ + TVA 5,5 %. Réseau d’artisans RGE, ingénierie financière incluse.';
